module.exports = __webpack_public_path__ + "media/organizations/mdr-1eaaee91.webp";